import {
  Button,
  Center,
  useToast,
  Flex,
  Image,
  Skeleton,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState, useRef } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getUsers, listUsers } from "../../graphql/queries";
import {
  Link as RouteLink,
  useParams,
  useSearchParams,
} from "react-router-dom";
import AWS from "aws-sdk";
import AWSAppSyncClient from "aws-appsync";
import gql from "graphql-tag";
import { whatBrowser } from "../../Service/Browser";
import { setCreds, setId } from "../../Features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { setBookingId, setGuestName, setbID } from "../../Features/guestSlice";
import { setPropertyId, clearPropertyId } from "../../Features/roomSlice";

AWS.config.update({
  region: "us-west-2",
  credentials: new AWS.Credentials(
    process.env.REACT_APP_PUBLIC_KEY,
    process.env.REACT_APP_SECRET_KEY
  ),
});

const Landing = () => {
  //Routing
  let { id, propertyId } = useParams();
  const [searchParams] = useSearchParams();
  const bID = searchParams.get("bID");
  const bookingId = searchParams.get("bookingId");
  const guestName = searchParams.get("guestName");

  //States
  const [manager, setManager] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [browser, setBrowser] = useState("");
  const toast = useToast();
  const isToastOpenedRef = useRef(false);

  useEffect(() => {
    // Clear localStorage when the component mounts
    localStorage.clear();

    // Dispatch the ID
    if (id) {
      dispatch(setId(id));
    }

    // Dispatch the ID
    if (bID) {
      dispatch(setbID(bID));
    }

    // Dispatch the bookingId and guestName if they exist
    if (bookingId) {
      dispatch(setBookingId(bookingId));
    }

    if (guestName) {
      dispatch(setGuestName(guestName));
    }

    // Handle propertyId with Redux
    if (propertyId) {
      dispatch(setPropertyId(propertyId));
    } else {
      dispatch(clearPropertyId());
    }
  }, [dispatch, id, bID, bookingId, guestName, propertyId]);

  useEffect(() => {
    fetchUser();
  }, []);

  const notice = () => {
    const browser = whatBrowser();
    if (browser === "Safari") {
      if (!isToastOpenedRef.current) {
        isToastOpenedRef.current = true;
        toast({
          title: "Important Note",
          position: "bottom",
          description:
            "Make sure you are using Chrome or Safari app to open this guest pass",
          status: "info",
          duration: 8000,
          isClosable: true,
        });
      }
    }
  };

  const query = gql`
    query GetUsers($id: String!) {
      getUsers(users: $id) {
        users
        email
        images
        name
        stripeId
        password
      }
    }
  `;

  const handleDownload = async (key) => {
    const s3 = new AWS.S3();

    if (!key) return;

    const params = {
      Bucket: process.env.REACT_APP_BUCKET,
      Key: `public/${key}`,
    };

    return new Promise((resolve, reject) => {
      s3.getSignedUrl("getObject", params, (err, url) => {
        if (err) {
          reject(err);
        } else {
          resolve(url);
        }
      });
    });
  };

  const runQuery = async () => {
    const client = new AWSAppSyncClient({
      url: process.env.REACT_APP_URL,
      region: "us-west-2",
      auth: {
        type: "API_KEY",
        apiKey: process.env.REACT_APP_API_KEY,
      },
      disableOffline: "false",
    });

    try {
      const result = await client.query({
        query,
        variables: { id },
      });
      return result.data.getUsers;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const fetchUser = async () => {
    try {
      const userData = await runQuery();

      if (!userData) {
        throw new Error("No user data found.");
      }

      dispatch(
        setCreds({
          email: userData.email,
          password: userData.password,
          stripeId: userData.stripeId,
        })
      );

      const imageDB = await handleDownload(userData.images);

      setManager({ ...userData, images: imageDB });
      setLoading(false);
    } catch (error) {
      console.log("error fetching users", error);
      toast({
        title: "Error",
        description: "There was an issue fetching user data.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Flex px={8} h={"77vh"} justifyContent={"center"} flexDirection="column">
        <Center flexDirection="column" alignItems={"start"}>
          <Text className="font-gilroy-bold">Welcome to</Text>

          {loading ? (
            <Skeleton w={"200px"} h={"50px"} borderRadius={"10px"} />
          ) : (
            <Text className="font-gilroy-bold" fontSize={"32px"}>
              {manager.name ? manager.name : "Custom Branding"}
            </Text>
          )}
        </Center>
        <Flex
          w={"full"}
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
        >
          {loading ? (
            <Center mt={8}>
              <Skeleton w={"250px"} h={"250px"} borderRadius={"20px"} />
            </Center>
          ) : (
            <Image
              mt={8}
              src={
                manager.images
                  ? manager.images
                  : "https://images.pexels.com/photos/3155666/pexels-photo-3155666.jpeg?auto=compress&cs=tinysrgb&w=860&h=650&dpr=2"
              }
              borderRadius={"20px"}
              w={"250px"}
              h={"250px"}
              objectFit={"cover"}
            />
          )}

          <Text className="font-gilroy-bold" mt={8} fontSize={"24px"}>
            Welcome to your stay
          </Text>
          <Text
            mt={2}
            textAlign={"center"}
            color={"#DFDFDF"}
            fontWeight={500}
            fontSize={"16px"}
          >
            This handy web app will support you throughout your stay
          </Text>
        </Flex>
      </Flex>
      <Center mt={4}>
        <Button
          as={RouteLink}
          to={`/auth`}
          color="white"
          bg={"#817EFF"}
          _hover={{ backgroundColor: "#504CFF" }}
          w={"full"}
          m={3}
          p={6}
          borderRadius={"60px"}
        >
          Get Started
        </Button>
      </Center>
    </>
  );
};
export default Landing;
